import { MilestoneLookup } from '@/store/milestones/types';
import { StandardIcon } from '../icon';

export function MilestoneItem({
  id,
  icon = true,
  size = 'sm',
}: {
  id: string;
  icon?: boolean;
  size?: 'sm' | 'md' | 'lg';
}) {
  const item = MilestoneLookup[id];
  if (!item) {
    return null;
  }

  return (
    <div className='flex flex-row items-center gap-2'>
      {icon && <StandardIcon id={item.icon} size={size === 'sm' ? 20 : 24} />}
      <span className={size === 'sm' ? 'text-sm' : 'text-medium'}>
        {item.label}
      </span>
    </div>
  );
}
